import { Backdrop, CircularProgress } from '@mui/material';

const FullScreenLoading = () => (
	<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }} open>
		<CircularProgress color="inherit" />
	</Backdrop>
);

export default FullScreenLoading;
